import { AppSettings } from '../model';

export function writeLog(...args) {
    // are we on debug mode?
    if(AppSettings.HOST != AppSettings.SERVER_HOST) {
        console.log('LOG ::', ...args);
    }
}

export function writeError(...args) {
    // are we on debug mode?
    if(AppSettings.HOST != AppSettings.SERVER_HOST) {
        console.error('ERROR ::', ...args);
    }
}

export function writeTrace(...args) {
    // are we on debug mode?
    if(AppSettings.HOST != AppSettings.SERVER_HOST) {
        console.trace('ERROR ::', ...args);
    }
}
